<div class="container">
  <mat-card appearance="outlined">
    <mat-card-title class="btn btn-rose">Edit Product</mat-card-title>
    <mat-card-subtitle></mat-card-subtitle>
    <mat-card-content>
      <form [formGroup]="editProductForm" (ngSubmit)="saveProduct()" novalidate>
        <div class="row">
          <div class="col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Product Name</mat-label>
              <input
                matInput
                formControlName="productName"
                placeholder="Product Name"
                appInputValidator
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
              />
              <mat-error
                *ngIf="editProductForm.get('productName').hasError('required')"
              >
                Product Name is required.
              </mat-error>
              <mat-error
                *ngIf="editProductForm.get('productName').hasError('maxlength')"
              >
                Product Name cannot be more than 50 characters.
              </mat-error>
              <mat-error *ngIf="editProductForm.get('productName').hasError('noAlphabet')">
                  Must contain at least one alphabet.
            </mat-error>
            </mat-form-field>
          </div>
          <div class="col-md-6">
            <mat-form-field appearance="fill" color="accent">
              <mat-label>Description</mat-label>
              <input
                matInput
                formControlName="description"
                placeholder="Description"
                appInputValidator
              [sanitizeScriptTags]="true"
              [hasAtLeastOneAlphabet]="true"
              />
              <mat-error
                *ngIf="editProductForm.get('description').hasError('required')"
              >
                Description is required.
              </mat-error>
              <mat-error
                *ngIf="editProductForm.get('description').hasError('maxlength')"
              >
                Description cannot be more than 100 characters.
              </mat-error>
               <mat-error *ngIf="editProductForm.get('description').hasError('noAlphabet')">
              Must contain at least one alphabet.
            </mat-error>
            </mat-form-field>
          </div>
        </div>
      </form>
    </mat-card-content>
    <mat-card-footer>
      <div class="row action-btn justify-content-center">
        <div class="row action-btn">
          <button
            md-raised-button
            type="button"
            class="btn btn-rose"
            (click)="close()"
          >
            Close
          </button>
          <button
            md-raised-button
            type="submit"
            class="btn btn-rose"
            (click)="saveProduct()"
            [disabled]="!editProductForm.valid || !isAdminGroupUser"
          >
            Update
          </button>
        </div>
      </div>
    </mat-card-footer>
  </mat-card>
</div>
